import React from "react";

const Datenschutzerklaerung = () => {
    return (
        <main className="flex-1 bg-zinc-900 text-zinc-200">
            <section className="w-full py-12 md:py-24 lg:py-32">
                <div className="container px-4 md:px-6 mx-auto">
                    <div className="flex flex-col items-center space-y-8 text-center">
                        <h1 className="text-4xl font-bold tracking-tighter sm:text-5xl md:text-6xl lg:text-7xl pb-8 text-primary">
                            Datenschutzerklärung
                        </h1>
                        <div className="w-full max-w-6xl text-left space-y-10">
                            {/* Einleitung */}
                            <section>
                                <h2 className="text-3xl font-semibold mb-6">1. Einleitung und Geltungsbereich</h2>
                                <p className="text-lg leading-relaxed">
                                    Der Schutz Ihrer persönlichen Daten ist uns ein besonderes Anliegen. Wir verarbeiten Ihre Daten daher ausschließlich auf Grundlage der gesetzlichen Bestimmungen (DSGVO, TKG 2003). In dieser Datenschutzerklärung informieren wir Sie über die wichtigsten Aspekte der Datenverarbeitung im Rahmen unserer Website.
                                </p>
                            </section>

                            {/* Verantwortliche Stelle */}
                            <section>
                                <h2 className="text-3xl font-semibold mb-6">2. Verantwortliche Stelle</h2>
                                <p className="text-lg leading-relaxed mb-6">
                                    Verantwortliche Stelle für die Datenverarbeitung auf dieser Website im Sinne der Datenschutz-Grundverordnung (DSGVO) ist:
                                </p>
                                <div className="space-y-6">
                                    <div>
                                        <h3 className="font-bold">Nowocode UG (haftungsbeschränkt)</h3>
                                        <p>
                                            Agricolastraße 8<br />
                                            38678 Clausthal-Zellerfeld<br />
                                            Telefon: <a href="tel:+4953292349988" className="text-primary hover:underline">+49 (0) 5329-2349988</a><br />
                                            E-Mail: <a href="mailto:info@nowocode.de" className="text-primary hover:underline">info@nowocode.de</a>
                                        </p>
                                    </div>
                                    <div>
                                        <h3 className="font-bold">SAVEUP24 Vergleichs Portal UG (haftungsbeschränkt)</h3>
                                        <p>
                                            Unter den Birken 14<br />
                                            38707 Clausthal-Zellerfeld - Schulenberg im Oberharz<br />
                                            Telefon: <a href="tel:+4953292349988" className="text-primary hover:underline">+49 (0) 5329-2349988</a><br />
                                            E-Mail: <a href="mailto:impressum@saveup24.de" className="text-primary hover:underline">impressum@saveup24.de</a>
                                        </p>
                                    </div>
                                </div>
                            </section>

                            {/* Datenerfassung auf unserer Webseite */}
                            <section>
                                <h2 className="text-3xl font-semibold mb-6">3. Datenerfassung auf unserer Webseite</h2>

                                <div className="space-y-8">
                                    {/* Server-Log-Dateien */}
                                    <div>
                                        <h3 className="text-2xl font-semibold mb-4">3.1 Server-Log-Dateien</h3>
                                        <p className="text-lg leading-relaxed mb-4">
                                            Beim Besuch unserer Webseite speichern unsere Server automatisch Informationen in sogenannten Server-Log-Dateien, die Ihr Browser automatisch an uns übermittelt. Diese Daten sind:
                                        </p>
                                        <ul className="list-disc list-inside space-y-2">
                                            <li>Besuchte Webseite</li>
                                            <li>Uhrzeit zum Zeitpunkt des Zugriffes</li>
                                            <li>Browser- und Betriebssystemtyp</li>
                                            <li>Referrer URL</li>
                                            <li>Hostname des zugreifenden Rechners</li>
                                            <li>IP-Adresse (zur Geolokalisierung)</li>
                                        </ul>
                                    </div>

                                    {/* Cookies */}
                                    <div>
                                        <h3 className="text-2xl font-semibold mb-4">3.2 Verwendung von Cookies</h3>
                                        <p className="text-lg leading-relaxed">
                                            Unsere Webseite verwendet Cookies. Cookies sind kleine Textdateien, die auf Ihrem Endgerät gespeichert werden und die eine Analyse der Benutzung der Webseite durch Sie ermöglichen. Sie können die Installation der Cookies durch eine entsprechende Einstellung Ihrer Browser-Software verhindern.
                                        </p>
                                    </div>

                                    {/* Google Analytics */}
                                    <div>
                                        <h3 className="text-2xl font-semibold mb-4">3.3 Google Analytics</h3>
                                        <p className="text-lg leading-relaxed">
                                            Diese Website benutzt Google Analytics, einen Webanalysedienst der Google LLC. Google Analytics verwendet Cookies, die Informationen über Ihre Benutzung dieser Website sammeln.
                                        </p>
                                    </div>

                                    {/* Kontaktformular */}
                                    <div>
                                        <h3 className="text-2xl font-semibold mb-4">3.4 Kontaktformular</h3>
                                        <p className="text-lg leading-relaxed">
                                            Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten bei uns gespeichert.
                                        </p>
                                    </div>
                                </div>
                            </section>

                            {/* Rechte der Nutzer */}
                            <section>
                                <h2 className="text-3xl font-semibold mb-6">4. Ihre Rechte</h2>
                                <p className="text-lg leading-relaxed mb-4">
                                    Ihnen stehen bezüglich Ihrer bei uns gespeicherten personenbezogenen Daten grundsätzlich die folgenden Rechte zu:
                                </p>
                                <ul className="list-disc list-inside space-y-2">
                                    <li>Recht auf Auskunft</li>
                                    <li>Recht auf Berichtigung</li>
                                    <li>Recht auf Löschung</li>
                                    <li>Recht auf Einschränkung der Verarbeitung</li>
                                    <li>Recht auf Datenübertragbarkeit</li>
                                    <li>Recht auf Widerspruch</li>
                                </ul>
                            </section>

                            {/* Kontakt */}
                            <section>
                                <h2 className="text-3xl font-semibold mb-6">5. Kontakt</h2>
                                <p className="text-lg leading-relaxed">
                                    Bei Fragen zur Erhebung, Verarbeitung oder Nutzung Ihrer personenbezogenen Daten wenden Sie sich bitte an:
                                </p>
                                <div className="space-y-6">
                                    <div>
                                        <h3 className="font-bold">Nowocode UG (haftungsbeschränkt)</h3>
                                        <p>
                                            Agricolastraße 8<br />
                                            38678 Clausthal-Zellerfeld<br />
                                            Telefon: <a href="tel:+4953292349988" className="text-primary hover:underline">+49 (0) 5329-2349988</a><br />
                                            E-Mail: <a href="mailto:info@nowocode.de" className="text-primary hover:underline">info@nowocode.de</a>
                                        </p>
                                    </div>
                                    <div>
                                        <h3 className="font-bold">SAVEUP24 Vergleichs Portal UG (haftungsbeschränkt)</h3>
                                        <p>
                                            Unter den Birken 14<br />
                                            38707 Clausthal-Zellerfeld - Schulenberg im Oberharz<br />
                                            Telefon: <a href="tel:+4953292349988" className="text-primary hover:underline">+49 (0) 5329-2349988</a><br />
                                            E-Mail: <a href="mailto:impressum@saveup24.de" className="text-primary hover:underline">impressum@saveup24.de</a>
                                        </p>
                                    </div>
                                </div>
                            </section>

                            {/* Footer Hinweis */}
                            <footer className="mt-12">
                                <p className="text-sm text-zinc-500 dark:text-zinc-400 text-center">
                                    Diese Datenschutzerklärung wurde zuletzt am 24.01.2025 aktualisiert.
                                </p>
                            </footer>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
};

export default Datenschutzerklaerung;
